export default "__VITE_ASSET__7$6OiRaq__"